import React, { useEffect, useState } from 'react'
import Header from '../common/header/Header'
import Home_Private_Confidential from '../pages/home_page_components/home_private_confidential/Home_Private_Confidential'
import Footer from '../common/footer/Footer'
import { useNavigate, useParams } from 'react-router-dom'
import { Get_Subhmuharats_Details } from '../../api/global/Global'
import { Helmet } from 'react-helmet'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../config/Config'
import Loader from '../../loader/Loader'
import { toast } from 'react-toastify'

const Shubh_Muhurat = () => {
    const navigate = useNavigate()
    const { slug } = useParams();
    const [is_loading, set_Is_Loading] = useState(false)
    const [subhmuharats_details_list, set_Subhmuharats_Details_List] = useState({})

    useEffect(() => {
        const Handle_Get_Subhmuharats_Details = async () => {
            set_Is_Loading(true)
            try {
                const response = await Get_Subhmuharats_Details(slug);
                set_Subhmuharats_Details_List(response?.data?.data?.subhmuharat)
                if (response?.data?.status == "200") {
                    set_Is_Loading(false)
                }
                if (response?.response?.data?.status == "500") {
                    toast.error(response?.response?.data?.message)
                    navigate("/")
                    set_Is_Loading(false)
                }
            }
            catch (error) {
                set_Is_Loading(false)
                console.error(error)
            }
        }
        Handle_Get_Subhmuharats_Details()
    }, [slug])

    // Scroll to the top of the page when the component is rendered

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <Helmet>
                <title>{subhmuharats_details_list?.meta_title}</title>
                <meta name="description" content={subhmuharats_details_list?.meta_description
                    || "description"} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}subh-muhurat/${subhmuharats_details_list?.slug}`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}subh-muhurat/${subhmuharats_details_list?.slug}`} />

            </Helmet>
            {/*  */}
            <Header />
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        <section className='banner-section'>
                            <div className={`${subhmuharats_details_list?.image ? "block" : "hidden"} relative`}>
                                <img src={`${IMG_BASE_URL}${subhmuharats_details_list?.image}`} alt={subhmuharats_details_list?.alt_image
                                } className='w-full h-[200px] md:h-[300px] lg:h-[400px] object-cover' />
                            </div>
                        </section>

                        <section className="gi-faq py-[40px] max-[767px]:py-[30px] px-4">
                            <div
                                class="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5">
                                <div className="sub__title text-[14px] mb-[16px]" dangerouslySetInnerHTML={{ __html: subhmuharats_details_list?.description }} />

                            </div>
                        </section>
                        {/*  */}
                        <Home_Private_Confidential />
                        {/*  */}
                        <Footer />
                    </>
                )
            }
        </div>
    )
}

export default Shubh_Muhurat